((app, ng) => {

    app.config($stateProvider => {
        $stateProvider.state("Home.ScheduledTask",
            {
                url: "/Task/{taskId}",
                component: "scheduledTask",
                resolve: {
                    task: (scheduledTaskApi, $transition$) => {
                        return scheduledTaskApi.getScheduledTask($transition$.params().taskId).then(task => Object.assign(task, {
                            // using this to export to ext. calendar
                            EndDate: new Date(task.DueDate.getFullYear(), task.DueDate.getMonth(), task.DueDate.getDate(), task.DueDate.getHours(), task.DueDate.getMinutes() + 30)
                        }));
                    },
                    notes: (scheduledTaskApi, $transition$) => {
                        return scheduledTaskApi.getScheduledTaskNotes($transition$.params().taskId);
                    }
                }
            });
    });

    app.component("scheduledTask",
        {
            templateUrl: "/App/ScheduledTask/scheduled-task.html",
            controller: scheduledTaskController,
            bindings: {
                task: "<",
                currentUser: "<",
                notes: "<"
            }
        });

    function scheduledTaskController($q, $window, $state, scheduledTaskApi, clientApi, userApi, modalService, FieldStatusesModel, appointmentApi, moment, $rootScope, $filter) {
        const $ctrl = this;

        this.$onInit = function () {
            $ctrl.notes.sort((a, b) => moment(b.CreatedOn) - moment(a.CreatedOn));
            updateExportCalendarDescription();
            $ctrl.savingStatusForTask = new FieldStatusesModel({
                TaskName: "",
                ClientName: "",
                TaskDueDate: "",
                TaskDueTime: "",
                AdvisorName: "",
                TaskColor: ""
            });
            $ctrl.ui = {
                loading: true
            };

            const promises = [
                userApi.getUsers()
            ];

            if ($ctrl.task.AppointmentId) {
                promises.push(appointmentApi.getAppointment($ctrl.task.AppointmentId));
            }

            $q.all(promises).then(responses => {
                $ctrl.users = responses[0];
                if (!!responses[1]) {
                    $ctrl.appointment = responses[2];
                }
                $ctrl.ui.loading = false;
            });
            //TODO: move isAllDay & endTime to backend model
            $ctrl.selectedDueDate = $ctrl.task.DueDate;
            $ctrl.selectedDueTime = $ctrl.task.DueDate;
            const dueDate = moment($ctrl.task.DueDate).format();
            const allDay = moment($ctrl.task.DueDate).hour(0).minute(0).second(0).format();
            $ctrl.taskIsAllDay = dueDate === allDay ? true : false;
        };

        const updateTaskDueDateTime = (task, propertyName, dueDate, dueTime) => {
            //TODO: move isAllDay & endTime to backend model
            if (dueDate instanceof Date) {
                if ($ctrl.taskIsAllDay) {
                    task.DueDate = new Date(dueDate.getFullYear(),
                        dueDate.getMonth(),
                        dueDate.getDate(),
                        dueTime.setHours(0),
                        dueTime.setMinutes(0));
                } else {
                    task.DueDate = new Date(dueDate.getFullYear(),
                        dueDate.getMonth(),
                        dueDate.getDate(),
                        dueTime.getHours(),
                        dueTime.getMinutes());
                }

            } else {
                if ($ctrl.taskIsAllDay) {
                    task.DueDate = new Date(`${dueDate} 00:00`);
                } else {
                    task.DueDate = new Date(`${dueDate} ${dueTime.getHours()}:${dueTime.getMinutes()}`);
                }
            }

            $ctrl.updateTask(task, propertyName);
        };


        const updateTask = (task, propertyName) => {
            $ctrl.savingStatusForTask.findFieldStatusByName(propertyName).startSaving();
            scheduledTaskApi.updateScheduledTask(task.Id, task)
                .then(function () {
                    $ctrl.savingStatusForTask.findFieldStatusByName(propertyName).succeed();

                })
                .then(() => {
                    if (!$ctrl.taskIsAllDay) $ctrl.task.EndDate = new Date(task.DueDate.getFullYear(), task.DueDate.getMonth(), task.DueDate.getDate(), task.DueDate.getHours(), task.DueDate.getMinutes() + 30);
                })
                .catch(function () {
                    $ctrl.savingStatusForTask.findFieldStatusByName(propertyName).fail();
                });
        };

        const updateColor = (parmeterTask, parameterFieldName, parameterColor) => {
            parmeterTask.Color = parameterColor;
            $ctrl.updateTask(parmeterTask, parameterFieldName);
        };

        const completeTask = (taskId) => {
            $ctrl.ui.completing = true;

            $ctrl.task.CompletedDate = new Date();

            scheduledTaskApi.completeScheduledTask(taskId).then(() => {
                $ctrl.ui.completing = false;
            }, () => {
                $ctrl.ui.completing = false;
            });
        };

        const deleteTask = (taskId, $event) => {
            modalService.confirmScheduledTaskDeletion($event).then(() => {
                $ctrl.ui.loading = true;

                scheduledTaskApi.deleteScheduledTask(taskId).then(() => {
                    $state.go("Home.Dashboard");
                }, () => {
                    $ctrl.ui.loading = false;
                });
            });
        };

        const addNote = (taskId, content) => {
            if (content.length > 0) {
                const note = {
                    Content: content,
                    CreatedBy: $ctrl.currentUser,
                    CreatedOn: new Date()
                };
                if ($ctrl.notes == null) {
                    $ctrl.notes = [];
                }
                $ctrl.notes.unshift(note);
                updateExportCalendarDescription();
                scheduledTaskApi.addScheduledTaskNote(taskId, note).then(response => {
                    note.NoteId = response.NoteId;
                });
            }
        };

        const updateNote = (taskId, note) => {
            if (note.NoteId && note.Content.length > 0) {
                scheduledTaskApi.updateScheduledTaskNote(taskId, note.NoteId, note);
                updateExportCalendarDescription();            }
        };

        const removeNote = (taskId, noteId) => {
            const noteIndex = $ctrl.notes.findIndex(note => note.NoteId === noteId);

            $ctrl.notes.splice(noteIndex, 1);
            updateExportCalendarDescription();
        };

        const searchClients = (term) => {
            if (term.length > 0) {
                return clientApi.searchClients(term).then(clients => clients);
            }

            return [];
        };

        const goToClient = (clientId) => {
            return $state.go("Home.Client", { "clientId": clientId });
        };

        const goToPreviousPage = () => {
            $window.history.back();
        };

        const updateExportCalendarDescription = () => {
            $ctrl.ExportCalendarDescription = `Scheduled task for ${$ctrl.task.Client.Person.FirstName} ${$ctrl.task.Client.Person.LastName} from ForceCRM` + "\n" + $ctrl.notes.map(n => `${$filter('date')(n.CreatedOn, 'MMM d, yyyy - h:mm a')} :  ${n.CreatedBy.FirstName} ${n.CreatedBy.LastName} ${n.Content}`).join("\n");
        };

        ng.extend($ctrl,
            {
                updateTask,
                completeTask,
                deleteTask,
                addNote,
                updateNote,
                removeNote,
                searchClients,
                goToClient,
                goToPreviousPage,
                updateColor,
                updateTaskDueDateTime
            });
    }

})(window.app, window.angular);